import { ICaroucelRelacionados } from "./icaroucel-relacionados";

export class CaroucelRelacionado {
  itemsEC_Destacados: ICaroucelRelacionados[];
  constructor() {
    this.itemsEC_Destacados = [];
  }
}
